module.exports = __webpack_public_path__ + "img/C08TechFireshipChampion_ua.040afd44.webp";